import { Routes, Route, Navigate } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import { useAuth } from './contexts/AuthContext'
import { Layout } from './pages/Layout'

import Login from './pages/public/Login'
import ConfirmacaoEmail from './pages/public/ConfirmacaoEmail'
import Recuperarsenha from './pages/public/Recuperarsenha'
import NotFound from './pages/public/NotFound/NotFound'
import Cadastro from './pages/public/Cadastro'

import Newproject from './pages/private/Newproject'
import Projects from './pages/private/Projects'
import Receipts from './pages/private/Receipts'
import Users from './pages/private/Users'
import Orcamento from './pages/private/Orcamento'
import GerarProcuracao from './pages/private/GerarProcuracao'
import Settings from './pages/private/Settings'

function PublicPage({ component: Component }) {
  const { isAuthenticated, booting } = useAuth()
  if (booting) return null
  return isAuthenticated ? <Navigate to="/meus-projetos" replace /> : <Component />
}

function ProtectedRoute({ children }) {
  const { isAuthenticated, booting } = useAuth()
  const location = useLocation()
  if (booting) return null
  if (!isAuthenticated) return <Navigate to="/login" replace state={{ from: location }} />
  return children
}

const RoutesApp = () => (
  <Routes>
    <Route path="/" element={<Navigate to="/login" replace />} />
    <Route path="/login" element={<PublicPage component={Login} />} />
    <Route path="/cadastro" element={<PublicPage component={Cadastro} />} />
    <Route path="/validar-conta" element={<ConfirmacaoEmail />} />
    <Route path="/redefinir-senha" element={<Recuperarsenha />} />

    <Route
      element={
        <ProtectedRoute>
          <Layout />
        </ProtectedRoute>
      }
    >
      <Route path="/meus-projetos" element={<Projects />} />
      <Route path="/orcamento" element={<Orcamento />} />
      <Route path="/solicitar-projeto" element={<Newproject />} />
      <Route path="/comprovantes" element={<Receipts />} />
      <Route path="/usuarios" element={<Users />} />
      <Route path="/gerar-procuracao" element={<GerarProcuracao />} />
      <Route path="/configuracoes" element={<Settings />} />
    </Route>

    <Route path="*" element={<NotFound />} />
  </Routes>
)

export { RoutesApp }
